import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ReportFilters } from '../../_models/preferences';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterService {
  private currentYear: string;

  constructor(private router: Router, private route: ActivatedRoute) { }

  resetFilters(): ReportFilters {
    let cleanfilter: ReportFilters = new ReportFilters;
    cleanfilter.groupID = null
    cleanfilter.reportQuery = null;

    return cleanfilter;
  }

  clearFilterParamsFromRoute() {
    const updatedParams: Params = {
      'groupID': null,
      'listDisplay': null
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: updatedParams,
        queryParamsHandling: 'merge'
      }
    );
  }
}
